import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export const scrollTo = () => {
  const targets = document.querySelectorAll('a[href^="#"]');
  const offsetY = window.innerHeight * 0.05;
  targets.forEach((target) => {
    target.addEventListener("click", (e) => {
      e.preventDefault();
      const anchor = target as HTMLAnchorElement;
      const elementWithDataset = target as HTMLElement;
      const baseOffset = elementWithDataset.dataset?.offsetY ? parseInt(elementWithDataset.dataset.offsetY) : offsetY;
      const extraOffset = 0;

      const hash = anchor.hash;
      const targetEl = hash ? (document.querySelector(hash) as HTMLElement | null) : null;
      let finalOffset = baseOffset;

      if (targetEl && hash) {
        const targetY = window.pageYOffset + targetEl.getBoundingClientRect().top;
        const currentY = window.pageYOffset;
        const isScrollUp = targetY < currentY;

        if (isScrollUp) {
          finalOffset = baseOffset + extraOffset;
        }

        // ブラウザのデフォルト動作を止めた代わりに、URL のハッシュだけは維持する
        if (history.pushState) {
          history.pushState(null, "", hash);
        } else {
          window.location.hash = hash;
        }
      }

      gsap.to(window, { duration: 0.8, scrollTo: { y: hash || 0, offsetY: finalOffset } });
    });
  });
};
